import { useState, useEffect } from 'react';
//redux
import { useSelector, useDispatch } from '../../redux/store';
import { setRiskLevelAII } from 'redux/slices/NuDetect';
import {
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormControl
} from '@mui/material';

export default function RiskLevelSelection() {
    const dispatch = useDispatch();
    const [riskLevel, setRiskLevel] = useState('low');

    const habndleChangeRiskLevel = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRiskLevel((event.target as HTMLInputElement).value);
    };

    useEffect(() => {
        dispatch(setRiskLevelAII(riskLevel))
    }, [riskLevel])

    return (
        <FormControl>
            <FormLabel id="demo-row-radio-buttons-group-label" sx={{ color: 'black' }}>Risk Level</FormLabel>
            <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                sx={{
                    gap: 1
                }}
                value={riskLevel}
                onChange={habndleChangeRiskLevel}
            >
                <FormControlLabel value="unknown" control={<Radio />} label="Unknown" />
                <FormControlLabel value="low" control={<Radio />} label="Low" />
                <FormControlLabel value="low-medium" control={<Radio />} label="Low-medium" />
                <FormControlLabel value="medium" control={<Radio />} label="Medium" />
                <FormControlLabel value="high" control={<Radio />} label="High" />
                <FormControlLabel value="very-high" control={<Radio />} label="Very-high" />
            </RadioGroup>
        </FormControl>
    )
}